webpackJsonp([102538987983895],{

/***/ 757:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/divider2.5314f141.jpg";

/***/ }),

/***/ 760:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kassenlotse.c8209613.jpg";

/***/ }),

/***/ 761:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/startupinspector.7f891aa2.jpg";

/***/ }),

/***/ 318:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(21);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _get = __webpack_require__(40);
	
	var _get2 = _interopRequireDefault(_get);
	
	var _sortBy = __webpack_require__(44);
	
	var _sortBy2 = _interopRequireDefault(_sortBy);
	
	var _reactHelmet = __webpack_require__(49);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _divider = __webpack_require__(757);
	
	var _divider2 = _interopRequireDefault(_divider);
	
	var _startupinspector = __webpack_require__(761);
	
	var _startupinspector2 = _interopRequireDefault(_startupinspector);
	
	var _kassenlotse = __webpack_require__(760);
	
	var _kassenlotse2 = _interopRequireDefault(_kassenlotse);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var HeaderComplete = function (_React$Component) {
		_inherits(HeaderComplete, _React$Component);
	
		function HeaderComplete() {
			_classCallCheck(this, HeaderComplete);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		HeaderComplete.prototype.render = function render() {
			// console.log("props", this.props)
			// const pageLinks = []
			// const site = get(this, 'props.data.site.siteMetadata')
			return _react2.default.createElement(
				'div',
				{ id: 'headerwrap', name: 'home', style: { backgroundImage: 'url(' + _divider2.default + ')' } },
				_react2.default.createElement(
					'header',
					{ className: 'clearfix' },
					_react2.default.createElement(
						'h1',
						null,
						_react2.default.createElement('span', { className: 'icon icon-w' })
					),
					_react2.default.createElement(
						'p',
						null,
						'Christian Wolter'
					)
				)
			);
		};
	
		return HeaderComplete;
	}(_react2.default.Component);
	
	var Footer = function (_React$Component2) {
		_inherits(Footer, _React$Component2);
	
		function Footer() {
			_classCallCheck(this, Footer);
	
			var _this2 = _possibleConstructorReturn(this, _React$Component2.call(this));
	
			_this2.state = {
				intervalId: 0
			};
			return _this2;
		}
	
		Footer.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		Footer.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		Footer.prototype.render = function render() {
			var _this3 = this;
	
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(
					'div',
					{ id: 'footerwrap' },
					_react2.default.createElement(
						'div',
						{ className: 'container' },
						_react2.default.createElement(
							'h4',
							null,
							_react2.default.createElement(
								'small',
								null,
								'created by Christian Wolter - copyright 2019 - ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/imprint', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'imprint | disclaimer'
								),
								' -  ',
								_react2.default.createElement(
									_gatsbyLink2.default,
									{ to: '/privacy', onClick: function onClick() {
											_this3.scrollToTop();
										} },
									'privacy'
								)
							)
						)
					)
				)
			);
		};
	
		return Footer;
	}(_react2.default.Component);
	
	var ScrollButton = function (_React$Component3) {
		_inherits(ScrollButton, _React$Component3);
	
		function ScrollButton() {
			_classCallCheck(this, ScrollButton);
	
			var _this4 = _possibleConstructorReturn(this, _React$Component3.call(this));
	
			_this4.state = {
				intervalId: 0
			};
			return _this4;
		}
	
		ScrollButton.prototype.scrollStep = function scrollStep() {
			if (window.pageYOffset === 0) {
				clearInterval(this.state.intervalId);
			}
			window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
		};
	
		ScrollButton.prototype.scrollToTop = function scrollToTop() {
			var intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
			this.setState({ intervalId: intervalId });
		};
	
		ScrollButton.prototype.render = function render() {
			var _this5 = this;
	
			return _react2.default.createElement(
				'button',
				{ title: 'Back to top', className: 'scroll',
					onClick: function onClick() {
						_this5.scrollToTop();
					} },
				_react2.default.createElement('span', { className: 'arrow-up glyphicon glyphicon-chevron-up' })
			);
		};
	
		return ScrollButton;
	}(_react2.default.Component);
	
	var Projects = function (_React$Component4) {
		_inherits(Projects, _React$Component4);
	
		function Projects() {
			_classCallCheck(this, Projects);
	
			return _possibleConstructorReturn(this, _React$Component4.apply(this, arguments));
		}
	
		Projects.prototype.render = function render() {
			var pathPrefix =  false ? '' : ("");
			return _react2.default.createElement(
				'div',
				null,
				_react2.default.createElement(HeaderComplete, null),
				_react2.default.createElement(
					'div',
					{ className: 'container', id: 'bachelorthesis', name: 'bachelorthesis' },
					_react2.default.createElement('br', null),
					_react2.default.createElement('br', null),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement(
							'h2',
							{ className: 'centered' },
							'Projects'
						),
						_react2.default.createElement('hr', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-offset-2 col-md-8' },
							_react2.default.createElement(
								'p',
								null,
								_react2.default.createElement(
									'small',
									null,
									'Steve Jobs:'
								),
								_react2.default.createElement('br', null),
								'\u201CSometimes when you innovate, you make mistakes. It is best to admit them quickly, and get on with improving your other innovations.\u201D'
							)
						),
						_react2.default.createElement('div', { className: 'col-md-2' })
					),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement('hr', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-offset-2 col-md-8' },
							_react2.default.createElement(
								'h3',
								null,
								_react2.default.createElement(
									'a',
									{ href: 'http://startup-inspector.de', target: '_blank' },
									_react2.default.createElement(
										'strong',
										null,
										'startup'
									),
									'INSPECTOR'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-8 col-sm-8 col-xs-12' },
									_react2.default.createElement(
										'p',
										null,
										'The startupINSPECTOR is the result of my masters thesis and coded by myself.'
									),
									_react2.default.createElement(
										'p',
										null,
										'The tool will help companies to improve their innovation management tasks by adding informations about start ups to their knowledge protfolio. The startupINSPECTOR combines trends and technologies with start ups in order to find new inspirations, technologies or investment oportunities.'
									),
									_react2.default.createElement(
										'p',
										null,
										'The range of functions and content are constantly being expanded and optimized. Right now it is possible to browse start ups and to discover related start ups, connected technologies and trends.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4 col-sm-4 col-xs-12' },
									_react2.default.createElement('img', { src: _startupinspector2.default, alt: 'Startup Inspector', className: 'img-responsive img-rounded' })
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-12' },
									_react2.default.createElement(
										'p',
										null,
										'The version 1.0 is available as a demo at ',
										_react2.default.createElement(
											'a',
											{ href: 'http://startup-inspector.de', target: '_blank' },
											'startup-inspector.de'
										),
										'.'
									)
								)
							)
						)
					),
					_react2.default.createElement(
						'div',
						{ className: 'row' },
						_react2.default.createElement('hr', null),
						_react2.default.createElement('br', null),
						_react2.default.createElement(
							'div',
							{ className: 'col-md-offset-2 col-md-8' },
							_react2.default.createElement(
								'h3',
								null,
								_react2.default.createElement(
									'a',
									{ href: 'http://kassenlotse.christian-wolter.com', target: '_blank' },
									'Kassenlotse'
								)
							),
							_react2.default.createElement(
								'div',
								{ className: 'row' },
								_react2.default.createElement(
									'div',
									{ className: 'col-md-8 col-sm-8 col-xs-12' },
									_react2.default.createElement(
										'p',
										null,
										'This was a portal to compare german health insurances plans, based on "IGEL Leistungen".'
									),
									_react2.default.createElement(
										'p',
										null,
										'The tool was the result of my bacherlor thesis and coded by myself. After two years I stopped the project but you can still take a look at ',
										_react2.default.createElement(
											'a',
											{ href: 'http://kassenlotse.christian-wolter.com', target: '_blank' },
											'kassenlotse.christian-wolter.com'
										),
										'.'
									),
									_react2.default.createElement(
										'p',
										null,
										'User: testuser',
										_react2.default.createElement('br', null),
										'PW: vuirMQ$74PYgmisivQExZzy'
									),
									_react2.default.createElement(
										'p',
										null,
										'Please note that the data is not up to date.'
									)
								),
								_react2.default.createElement(
									'div',
									{ className: 'col-md-4 col-sm-4 col-xs-12' },
									_react2.default.createElement('img', { src: _kassenlotse2.default, alt: 'Kassenlotse', className: 'img-responsive img-rounded' })
								)
							)
						)
					)
				),
				_react2.default.createElement(ScrollButton, { scrollStepInPx: '50', delayInMs: '16.66' }),
				_react2.default.createElement(Footer, null)
			);
		};
	
		return Projects;
	}(_react2.default.Component);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-index-jsx-5d960b617c215fd9e1e5.js